import { generateUID } from "verdi-common/utils/HelperFunctions";
import MapEntityBase from "./map-entity-base";

export default class IrrigationSetMapEntity extends MapEntityBase {
    /**
     *  @type {IrrigationSet}
     */
    // redeclaration of model is just to specify a different type from the base class
    // required for the migration to es2022 with Vite
    get model() {
        return this.model;
    }

    /**
     * @param {IrrigationSet} IrrigationSet
     */
    constructor(IrrigationSet, renderImmediately = true) {
        super(IrrigationSet, generateUID("IrrSet"), false);
        this.lat = undefined;
        this.long = undefined;

        // this.icon = DeviceMarkerIcon;
        if (renderImmediately) {
            this.renderOnMap();
        }
    }

    renderOnMap() {
        if (!this.renderState.onMap && !this.renderState.beingRendered) {
            this.renderState.beingRendered = true;
        }
    }
}
